import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  quantidade: Yup.string().numero().nullable().required(mensagemPadrao),
  valorParcela: Yup.string().numero().nullable().required(mensagemPadrao),
  primeiroVencimento: Yup.string().nullable().data().required(mensagemPadrao),
  tipoCobranca: Yup.string().required(mensagemPadrao)
})
